import { useTranslation } from 'react-i18next';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import { useGetUserProfileQuery } from '~/redux/api/authApiSlice';
import PageLayout from '~myAccount/components/PageLayout';
import UserTitle from '~myAccount/pages/AccountDetails/UserTitle';
import UserEmail from '~myAccount/components/UserEmail';
import UserPassword from '~/modules/myAccount/components/UserPassword';
import UserPhoneNumber from '~/modules/myAccount/components/UserPhoneNumber';
import LayoutSkeleton from '~/components/LayoutSkeleton';

function AccountInfo() {
  const { t } = useTranslation('app');
  const { isLoading } = useGetUserQuery();
  const { isLoading: isLoadingProfile } = useGetUserProfileQuery();

  return (
    <PageLayout
      title={t('accountDetails')}
      bodyClassName="border border-gray rounded-[8px]"
    >
      <div className="flex flex-col py-3x">
        {isLoading || isLoadingProfile ? (
          <div className="px-3x flex flex-col gap-4">
            {Array.from({ length: 4 }).map((_, index) => (
              <LayoutSkeleton key={`layout-skeleton-${index}`} />
            ))}
          </div>
        ) : (
          <>
            <UserTitle />
            <UserEmail />
            <UserPassword />
            <UserPhoneNumber />
          </>
        )}
      </div>
    </PageLayout>
  );
}

export default AccountInfo;
